/* SBI CUSTOM - bead bracelets bulk order page (sbi-bead-bracelets). Loaded with defer by sections/sbi-bead-bulk.liquid.
   Rows are server-rendered; this adds filters, sort, ticks, steppers, +3/+5, and a dock that adds everything with ONE
   /cart/add.js call (items[]). URL presets: ?q=amethyst&size=8mm&for=calm (used by links from the collection + PDPs). */
(function () {
  var root = document.querySelector('[data-bb]');
  if (!root || root.__bb) return;
  root.__bb = true;

  var rowsWrap = root.querySelector('[data-bb-rows]');
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));
  var dock = root.querySelector('[data-bb-dock]');
  var btnAll = root.querySelector('[data-bb-addall]');
  var state = { q: '', size: 'all', group: 'all', instock: false, sort: 'rank', tick: 1 };
  var KEY = 'sbiBeadBulk';

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY) || '{}'); sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return {}; } }
  function qtyInput(r) { return r.querySelector('[data-bb-qty]'); }
  function maxOf(r) { var m = parseInt(r.getAttribute('data-max'), 10); return isNaN(m) ? 99 : Math.max(0, m); }

  function setQty(r, n, quiet) {
    var i = qtyInput(r); if (!i) return;
    var max = maxOf(r), q = Math.max(0, Math.min(isNaN(n) ? 0 : n, max));
    i.value = q;
    var t = r.querySelector('[data-bb-tick]'); if (t) t.checked = q > 0;
    r.classList.toggle('is-picked', q > 0);
    if (!quiet && n > max && max > 0) toast('Only ' + max + ' available for that one, so we set it to ' + max + '.', true);
    sum();
  }

  function sum() {
    var n = 0, styles = 0, total = 0, sel = {};
    rows.forEach(function (r) {
      var i = qtyInput(r); if (!i) return;
      var q = parseInt(i.value, 10) || 0;
      if (q > 0) { n += q; styles += 1; total += q * parseFloat(r.getAttribute('data-price')); sel[r.getAttribute('data-vid')] = q; }
    });
    root.querySelector('[data-bb-n]').textContent = n;
    root.querySelector('[data-bb-nlabel]').textContent = n === 1 ? 'item' : 'items';
    root.querySelector('[data-bb-styles]').textContent = styles;
    root.querySelector('[data-bb-total]').textContent = money(total);
    btnAll.disabled = n === 0;
    dock.classList.toggle('is-on', n > 0);
    dock.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
    store(sel);
  }

  function apply() {
    var q = state.q.trim().toLowerCase(), shown = 0;
    rows.forEach(function (r) {
      var ok = true;
      if (q && r.getAttribute('data-name').indexOf(q) === -1) ok = false;
      if (ok && state.size !== 'all' && r.getAttribute('data-size') !== state.size) ok = false;
      if (ok && state.group !== 'all' && (' ' + r.getAttribute('data-groups') + ' ').indexOf(' ' + state.group + ' ') === -1) ok = false;
      if (ok && state.instock && r.getAttribute('data-instock') !== '1') ok = false;
      r.classList.toggle('is-hidden', !ok);
      if (ok) shown += 1;
    });
    root.querySelector('[data-bb-shown]').textContent = shown + ' of ' + rows.length + ' shown';
    root.querySelector('[data-bb-empty]').hidden = shown !== 0;
  }

  function sortRows() {
    var k = state.sort, s = rows.slice();
    var num = function (r, a) { return parseFloat(r.getAttribute(a)) || 0; };
    s.sort(function (a, b) {
      if (k === 'name') return a.getAttribute('data-sort').localeCompare(b.getAttribute('data-sort')) || num(a, 'data-rank') - num(b, 'data-rank');
      if (k === 'price-asc') return num(a, 'data-price') - num(b, 'data-price');
      if (k === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
      if (k === 'stock') return num(b, 'data-stock') - num(a, 'data-stock');
      return num(a, 'data-rank') - num(b, 'data-rank');
    });
    var frag = document.createDocumentFragment();
    s.forEach(function (r) { frag.appendChild(r); });
    rowsWrap.appendChild(frag);
  }

  function pick(groupSel, attr, val) {
    root.querySelectorAll(groupSel + ' button').forEach(function (b) {
      var on = b.getAttribute(attr) === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var toastEl = root.querySelector('[data-bb-toast]');
  function toast(msg, err, cartLink) {
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(msg));
    if (cartLink) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View cart'; toastEl.appendChild(a); }
    toastEl.classList.toggle('is-err', !!err);
    toastEl.hidden = false;
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.hidden = true; }, err ? 6000 : 4500);
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-js-cart-count], [data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    }).catch(function () {});
  }

  function post(items) {
    /* SBI CUSTOM (sbi-bead-strands-bulk 2026-10-18): attribution - hidden line-item property _bulk = 'beads' on every line added
       here; it stays on the order line (Admin API lineItems.customAttributes), counted by sbi-bead-strands-bulk/scripts/bulk_usage.py */
    items = items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: { _bulk: 'beads' } }; });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not add to cart'); e.status = r.status; throw e; } return j; }); });
  }

  /* --- events --- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-size]');
    if (b && b.tagName === 'BUTTON') { state.size = b.getAttribute('data-size'); pick('[data-bb-sizes]', 'data-size', state.size); apply(); return; }
    b = t.closest('[data-group]');
    if (b && b.tagName === 'BUTTON') { state.group = b.getAttribute('data-group'); pick('[data-bb-groups]', 'data-group', state.group); apply(); return; }
    b = t.closest('[data-bb-tickqty] button');
    if (b) { state.tick = parseInt(b.getAttribute('data-n'), 10) || 1; pick('[data-bb-tickqty]', 'data-n', String(state.tick)); return; }
    var r = t.closest('[data-row]');
    if (r && t.closest('[data-bb-inc]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + 1); return; }
    if (r && t.closest('[data-bb-dec]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) - 1, true); return; }
    b = t.closest('[data-bb-add]');
    if (r && b) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + parseInt(b.getAttribute('data-bb-add'), 10)); return; }
    if (t.closest('[data-bb-reset]')) { reset(); return; }
    if (t.closest('[data-bb-clear]')) { rows.forEach(function (x) { setQty(x, 0, true); }); return; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target, r = t.closest('[data-row]');
    if (t.matches('[data-bb-tick]') && r) { setQty(r, t.checked ? Math.max(parseInt(qtyInput(r).value, 10) || 0, state.tick) : 0); return; }
    if (t.matches('[data-bb-qty]') && r) { setQty(r, parseInt(t.value, 10) || 0); return; }
    if (t.matches('[data-bb-instock]')) { state.instock = t.checked; apply(); return; }
    if (t.matches('[data-bb-sort]')) { state.sort = t.value; sortRows(); return; }
  });
  var qIn = root.querySelector('[data-bb-q]'), qT;
  qIn.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(function () { state.q = qIn.value; apply(); }, 120); });

  function reset() {
    state.q = ''; qIn.value = ''; state.size = 'all'; state.group = 'all'; state.instock = false;
    root.querySelector('[data-bb-instock]').checked = false;
    pick('[data-bb-sizes]', 'data-size', 'all'); pick('[data-bb-groups]', 'data-group', 'all'); apply();
  }

  btnAll.addEventListener('click', function () {
    var items = [], picked = [];
    rows.forEach(function (r) {
      var i = qtyInput(r), q = i ? parseInt(i.value, 10) || 0 : 0;
      if (q > 0) { items.push({ id: +r.getAttribute('data-vid'), quantity: q }); picked.push(r); }
    });
    if (!items.length) return;
    btnAll.disabled = true; btnAll.textContent = 'Adding...';
    var total = items.reduce(function (a, b) { return a + b.quantity; }, 0);
    var done = function (added, failed) {
      btnAll.textContent = 'Add all to cart';
      picked.forEach(function (r) { if (failed.indexOf(r) === -1) setQty(r, 0, true); });
      refreshCart();
      if (failed.length) {
        toast('Added ' + added + ' items. ' + failed.length + ' could not be added (stock changed); they are still ticked.', true, true);
      } else {
        toast('Added ' + added + ' items to your cart.', false, true);
      }
      sum();
    };
    post(items).then(function () { done(total, []); }).catch(function () {
      /* one bad line rejects the whole call: fall back to one call per line so the rest still lands */
      var added = 0, failed = [], chain = Promise.resolve();
      items.forEach(function (it, k) {
        chain = chain.then(function () { return post([it]).then(function () { added += it.quantity; }).catch(function () { failed.push(picked[k]); }); });
      });
      chain.then(function () { done(added, failed); });
    });
  });

  /* --- start: URL presets, restore selection --- */
  var u = new URLSearchParams(location.search);
  if (u.get('q')) { state.q = u.get('q'); qIn.value = state.q; }
  if (u.get('size')) { state.size = u.get('size'); pick('[data-bb-sizes]', 'data-size', state.size); }
  if (u.get('for')) { state.group = u.get('for'); pick('[data-bb-groups]', 'data-group', state.group); }
  var saved = store();
  rows.forEach(function (r) { var q = saved[r.getAttribute('data-vid')]; if (q) setQty(r, q, true); });
  apply(); sum();
})();
